/* eslint-disable */
import React, { Component } from 'react';
import {
  Alert,
  FormGroup,
  Button,
  Col,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  // Media,
} from 'reactstrap';
import ReactImageMagnify from 'react-image-magnify';
import PropTypes from 'prop-types';
// import role from '../../../ProjectConfiguration/role.json';

class NextReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reportPrefix: '',
      reportSerched: false,
      refreshFind: true,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.onSearchClick = this.onSearchClick.bind(this);
  }

  componentDidMount() {
    console.log('Hello');
  }

  onSearchClick() {
    console.log('-------report id prefix--------');
    console.log(this.state.reportPrefix);
    this.props.actions.getNextReport({
      reportIdPrefix: this.state.reportPrefix,
      LastEvaluatedKey: this.state.refreshFind ? null : this.props.LastEvaluatedKey,
    });
    this.setState({
      reportSerched: true,
      refreshFind: false,
    });
    console.log(this.props.nextReport);
  }

  handleInputChange(event) {
    this.setState({
      reportPrefix: event.target.value,
      refreshFind: true,
    });
  }

  /* eslint class-methods-use-this:0 */

  render() {
    return (
      <div>
        <FormGroup row className="mt-2">
          <Col md="8">
            <InputGroup>
              <InputGroupAddon addonType="prepend">
                <InputGroupText>Report Prefix</InputGroupText>
              </InputGroupAddon>
              <Input
                type="text"
                id="input1-group1"
                onChange={this.handleInputChange}
                placeholder="Enter Report ID"
                value={this.state.reportPrefix && this.state.reportPrefix}
              />
            </InputGroup>
          </Col>
          <Col md="4">
            <Button type="submit" color="success" onClick={this.onSearchClick}>
              Get Next Report
            </Button>
          </Col>
        </FormGroup>
        {this.props.nextReport === null ||
        this.props.nextReport.imageLink === undefined ? (
          this.state.reportSerched ? (
            <Alert color="warning">Report Not Found</Alert>
          ) : (
            <Alert color="success">
              Enter Report ID Prefix and Press Get Next Report
            </Alert>
          )
        ) : (
          <ReactImageMagnify
            {...{
              smallImage: {
                alt: 'Wristwatch by Ted Baker London',
                width: 500,
                height: 500,
                src: `https://s3.us-west-2.amazonaws.com/${
                  this.props.nextReport.imageLink.Bucket
                }/${this.props.nextReport.imageLink.Key}`,
              },
              largeImage: {
                src: `https://s3.us-west-2.amazonaws.com/${
                  this.props.nextReport.imageLink.Bucket
                }/${this.props.nextReport.imageLink.Key}`,
                width: 1000,
                height: 1000,
              },
            }}
          />
        )}
      </div>
    );
  }
}

NextReport.defaultProps = {
  nextReport: null,
  LastEvaluatedKey: null,
};

NextReport.propTypes = {
  nextReport: PropTypes.shape(),
  LastEvaluatedKey: PropTypes.shape(),
  actions: PropTypes.shape({
    getNextReport: PropTypes.func,
  }).isRequired,
};

export default NextReport;



// WEBPACK FOOTER //
// ./src/components/Reports/PrefixScan.js